<template>
  <div>
    <label class="block text-sm font-medium mb-1" :style="{ color: labelColor }">
      {{ label }}
    </label>
    <input :type="type" v-model="inputValue" :placeholder="placeholder"
      class="custom-input mt-1 p-2 block w-full rounded-md shadow-sm sm:text-sm border"
      :class="{ 'border-red-500': isInvalid }"
      :style="{ '--placeholder-color': placeholderColor, backgroundColor: bgColor, color: textColor }"
      :disabled="disabled"
      />
    <p v-if="isInvalid" class="text-red-500 text-xs mt-1">Correo electrónico no válido</p>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'text',
  },
  label: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  placeholderColor: {
    type: String,
    default: '#000000',
  },
  bgColor: {
    type: String,
    default: '#FFFFFF',
  },
  textColor: {
    type: String,
    default: '#25B0D7',
  },
  labelColor: {
    type: String,
    default: '#385660',
  },
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['update:modelValue']);

const inputValue = ref(props.modelValue);
const isInvalid = ref(false);

watch(inputValue, (newValue) => {
  emit('update:modelValue', newValue);

  if (props.type === 'email') {
    isInvalid.value = !validateEmail(newValue);
  } else {
    isInvalid.value = false;
  }
});

function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}
</script>

<style scoped>
.custom-input::placeholder {
  color: var(--placeholder-color);
}
</style>
